import { apiAxios } from "./apiConfig";

/* ---------- Types ---------- */

export interface QuestionOption {
  id: string;
  optionName: string;
  isActive: boolean;
  optionOrder: number;
}

export interface QuestionUpdater {
  id: string;
  name: string;
}

export interface QuestionCreator {
  id: string;
  name: string;
}
export interface Question {
  id: string;
  questionName: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  options: QuestionOption[];
  updater: QuestionUpdater;
  creator: QuestionCreator;
}

export interface QuestionListResponse {
  status: boolean;
  data: Question[];
}

/* ---------- API Function ---------- */

export const getQuestionList = async (): Promise<QuestionListResponse> => {
  const response = await apiAxios.get<QuestionListResponse>("/question/list");
  return response.data;
};
export interface QuestionOptionPayload {
  optionName: string;
  optionOrder: number;
}

export interface CreateQuestionPayload {
  questionName: string;
  questionDescription: string;
  options: QuestionOptionPayload[];
}

export interface UpdateQuestionPayload extends CreateQuestionPayload {
  isActive: boolean;
}

export interface QuestionResponse {
  status: boolean;
  data: any;
}

/* ---------- APIs ---------- */

export const createQuestion = async (
  payload: CreateQuestionPayload,
): Promise<QuestionResponse> => {
  const response = await apiAxios.post<QuestionResponse>(
    "/question/create",
    payload,
  );
  return response.data;
};

export const updateQuestion = async (
  id: string,
  payload: UpdateQuestionPayload,
): Promise<QuestionResponse> => {
  const response = await apiAxios.put<QuestionResponse>(
    `/question/${id}`,
    payload,
  );
  return response.data;
};

